import React, { Component } from "react";

import { Button, Row, Col, FormGroup, Form, ControlLabel, FormControl, Checkbox, Modal ,Glyphicon} from "react-bootstrap";
import Switch from 'react-bootstrap-switch';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import Loading from "../../components/loading";
import SettingsModal from "../../components/settings-alert";

import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css";

import "./style.css";

import {ToastContainer, ToastStore} from 'react-toasts';

import UsersService from "../../services/users-service";
import IncidentsService from "../../services/incidents-service";
import EmailService from "../../services/email-service";

import Moment from 'react-moment';
import _ from 'underscore';

import { AsYouType } from 'libphonenumber-js';
import DatePicker from 'react-16-bootstrap-date-picker';
import TimePicker from 'react-bootstrap-time-picker';
import { SegmentedControl } from 'segmented-control'

import moment from 'moment';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import UtilsService from "../../services/utils-service";

class AddIncident extends Component {
    constructor(props) {
        super(props);

        var user = UsersService.sharedInstance.getStoredCredentials();

        this.state = {
            license: user.license,
            user_auth: user.username,
            token: user.token,
            loginResponse: user.loginResponse,

            message: '',
            isShowing: false,
            showWarningModal: false,
            individual_count: 1,

            dispatch_no: ' - ',
            incident_type_id: '',
            facility_id: '',
            facility_location_id: '',
            location_description: '',
            individuals_data: [],
            external_agency_data: [],
            auto_email_id: '',
            auto_email_value: '',
            sub_user_id: user.loginResponse.data[0].recno,
            date_added: new Date(),
            files: [],
            time_dispatched: '',
            time_arrived: '',
            time_cleared: '',

            hasChanged: false,
            show_agency_section: false,
            show_email_section: false,
            checkedFireDepartment: false,
            checkedPolice: false,
            checkedAmbulance: false,  
            isSubmittingIncident: false,
            submitMessage: "Submitting Incident...",
            link_modal:false,
            linked_files:[]
        }

        this.handleTimeDispatchedChange = this.handleTimeDispatchedChange.bind(this);
        this.handleTimeArrivedChange = this.handleTimeArrivedChange.bind(this);
        this.handleTimeClearedChange = this.handleTimeClearedChange.bind(this);
        this.handleAddEmail = this.handleAddEmail.bind(this);
        this.handleSubmitIncident = this.handleSubmitIncident.bind(this);
        this.handleAddFile = this.handleAddFile.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.convertCanvasToPDF = this.convertCanvasToPDF.bind(this);
        this.findAutoEmailById = this.findAutoEmailById.bind(this);
        this.renderAllIndividualFields = this.renderAllIndividualFields.bind(this);
        this.handleUpdateIncident = this.handleUpdateIncident.bind(this);
        this.handleAddIndividual = this.handleAddIndividual.bind(this);
        this.parseIndividualsArray = this.parseIndividualsArray.bind(this);
    }

    render() {
        return (
            <div>
                <div className="content-div">
                        {/* <h1 className="orange-header">Create New Incident Report</h1> */}
                        {this.renderHeaderSection()}
                        {this.renderForm()}
                </div>
                {this.renderLinkedModal()}
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                <SettingsModal isShowing={this.state.showWarningModal} cancelButton={this.handleExitButton} continueButton={this.handleContinueButton}/>
                { <Loading isShowing={this.state.isSubmittingIncident} message={this.state.submitMessage}/>}
            </div>
        )
    }

    getIncidentTitle = (data) =>{
        try{
            const individuals_data = UtilsService.sharedInstance.tryParseJSON(data.individuals_data);
            const individual = individuals_data && individuals_data.length ? individuals_data[0] : false;

            const title = individual && individual.name ? individual.name : '';
            return title;
        }catch(err){
            console.error('Error',err);

            return '';
        }
    }

    getLinkedFiles = (data) =>{
        try{
            const other_form_data = UtilsService.sharedInstance.tryParseJSON(data.other_form_data);
            const linked_files = other_form_data.linked_files && (other_form_data.linked_files).length ? other_form_data.linked_files : [];
            const resultset = [];

            for(let x = 0; x < (linked_files).length; x++){
                const {title} = linked_files[x];

                if(title){
                    resultset.push(linked_files[x]);
                }else{
                    linked_files[x].title = this.getIncidentTitle(linked_files[x]);

                    resultset.push(linked_files[x]);
                }
            }

            return resultset;
        }catch(err){
            console.log('Error',err);
            return [];
        }
    }

    componentDidMount() {
        const editMode = this.props.itemToEdit != null ? true : false;
        if (editMode){
            const {itemToEdit} = this.props;
            const linked_files = this.getLinkedFiles(itemToEdit);

            const currentItemToEdit = this.props.itemToEdit;
            const checkEmailSection = currentItemToEdit.auto_email_id > 0 ? true: false;

            const external_agency_data = UtilsService.sharedInstance.tryParseJSON(currentItemToEdit.external_agency_data) ? JSON.parse(currentItemToEdit.external_agency_data) : [];

            const checkAgencySection = external_agency_data.length > 0 ? true: false;

            const fireDepartmentData = this.getExternalAgencyValue('fire_department');
            const dispatchTimeValue = fireDepartmentData["time"];
            const hasFireDepartment = fireDepartmentData["isChecked"] ? "on" : "off";


            const policeData = this.getExternalAgencyValue('police');
            const arrivalTimeValue = policeData["time"];
            const hasPolice = policeData["isChecked"] ? "on" : "off";

            const ambulanceData = this.getExternalAgencyValue('ambulance');
            const clearedTimeValue = ambulanceData["time"];
            const hasAmbulance = ambulanceData["isChecked"] ? "on" : "off";

            const json_data = UtilsService.sharedInstance.tryParseJSON(this.props.itemToEdit.individuals_data) ? JSON.parse(this.props.itemToEdit.individuals_data) : []; 

            this.setState({
                editMode: true,
                dispatch_no: currentItemToEdit.dispatch_no,
                incident_type_id: this.findIncidentID(currentItemToEdit.incident_type),
                facility_id: this.findFacilityID(currentItemToEdit.facility_name),
                facility_location_id: currentItemToEdit.facility_location_id,
                location_description: currentItemToEdit.location_description,
                individuals_data: currentItemToEdit.individuals_data,
                external_agency_data: currentItemToEdit.external_agency_data,
                auto_email_id: currentItemToEdit.auto_email_id,
                auto_email_value: currentItemToEdit.auto_email,
                show_email_section: checkEmailSection,
                show_agency_section: checkAgencySection,
                individual_count: json_data.length,

                date_added: new Date(currentItemToEdit.date_added),
                files: currentItemToEdit.files != null ? currentItemToEdit.files : [],

                time_dispatched: dispatchTimeValue,
                checkedFireDepartment: hasFireDepartment,

                time_arrived: arrivalTimeValue,
                checkedPolice: hasPolice,

                time_cleared: clearedTimeValue,
                checkedAmbulance: hasAmbulance,
                linked_files:linked_files
            });

            this.parseIndividualsArray();
        }
    }

    parseIndividualsArray(){
        var json_data = JSON.parse(this.props.itemToEdit.individuals_data);
        var counter = 1;

        const elements = [];

        for (var i = 0; i < this.state.individual_count; i++){
            let controlID = "individual_name_"+counter;
            let individual_role = "individual_role"+counter;
            let segmentControl = "edit_individual_role_"+counter;
            let narrative = "narrative_"+counter;

            // Declarations:
            var isOffender = true;
            var isWitness = false;
            var isVictim = false;
            var isOther = false;

            var userType = "witness";

            var options = [];

            var option1 = { label: "Offender", value: "offender"};
            var option2 = { label: "Witness", value: "witness"};
            var option3 = { label: "Victim", value: "victim"};
            var option4 = { label: "Other", value: "other"};

            var individual_name = "";
            var narrative_value = "";

            // Handle if user is not
            if (json_data[i] != null){
                isOffender = json_data[i].type == "offender" ? true : false;
                isWitness = json_data[i].type == "witness" ? true : false;
                isVictim = json_data[i].type == "victim" ? true : false;
                isOther = json_data[i].type == "other" ? true : false;

                userType = json_data[i].type;

                options = [];

                option1 = isOffender ? { label: "Offender", value: "offender", default: true} : { label: "Offender", value: "offender"};
                option2 = isWitness ? { label: "Witness", value: "witness", default: true} : { label: "Witness", value: "witness"};
                option3 = isVictim ? { label: "Victim", value: "victim", default: true} : { label: "Victim", value: "victim"};
                option4 = isOther ? { label: "Other", value: "other", default: true} : { label: "Other", value: "other"};

                options.push(option1);
                options.push(option2);
                options.push(option3);
                options.push(option4);

                individual_name = this.state[controlID] == null ? json_data[i].name : this.state[controlID];
                narrative_value = this.state[narrative] == null ? json_data[i].narrative : this.state[narrative];

                this.setState({
                    [controlID]: individual_name,
                    [individual_role]: userType,
                    [narrative]: narrative_value,
                });
            }

            counter+=1;
        }
    }

    componentWillReceiveProps(){

    }

    renderForm(){
        return(
            <div id="IncidentCanvasForm" className="add-user-content">
                    <Form className="add-incident-form">
                        { this.renderFormSection() }
                        { this.renderLinkedFileSection() }
                        { this.renderEmailSection() }
                        { this.renderFooterSection() }
                    </Form>
                    { <Loading isShowing={this.state.isShowing} message={this.state.message}/>}
            </div>
        )
    }

    renderHeaderSection(){

        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }

        var month = months[this.state.date_added.getMonth()];
        var date = month + " " + this.state.date_added.getDate() + ", " + this.state.date_added.getFullYear();
        var time = this.state.date_added.formattedTime();

        var title = this.state.editMode == true ? "Edit Incident Data" : "Create New Incident Report";

        return(
            <div className="incident-header">
                <div className="incident-title">
                    <h1 className="orange-title left">{title}</h1>
                </div>
                <div className="incident-dispatch-info">
                    <div className="incident-dispatch-block">
                        <h5 className="incident-card-text">Dispatch No.</h5>
                        <h5 className="dispatch-date-value">{this.state.dispatch_no}</h5>
                    </div>

                    <div className="incident-date-block">
                        <h5 className="incident-card-text">Date</h5>
                        {/* <Button className="incident-edit-button">Edit</Button> */}
                        <h5 className="dispatch-date-value">{date}</h5>
                        <h5 className="dispatch-date-value">@ {time}</h5>
                    </div>
                </div>
            </div>
        )
    }

    renderFormSection(){
        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;
        let incident_types = this.props.incident_types;
        let auto_emails = this.props.auto_emails;

        let hasFacilityLocations = (facility_locations && facility_locations.length)
        let hasFacilities = (facilities && facilities.length > 0)
        let hasIncidentTypes = (incident_types && incident_types.length > 0);
        let hasAutoEmails =  (auto_emails && auto_emails.length > 0);

        return(
            <div className="incident-section">
                <h3 className="sub-title">Incident Information</h3>
                <hr className="line"/>

                <div className="left-side-content">
                    <FormGroup controlId="type_of_incident" bsSize="sm">
                        <ControlLabel className="login_label">Type of Incident</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                           style={{width: "100%"}}
                           value={this.state.incident_type_id ? this.state.incident_type_id : ""}
                           onChange={(e)=>{this.setState({incident_type_id: e.target.value})}}>
                                {hasIncidentTypes ? <option value={"select"}>Select Incident Type</option> : null}
                                {hasIncidentTypes
                                    ? incident_types.map((incident_type) => {
                                            if(incident_type.is_active == 1)
                                                return <option key={incident_type.recno} value={incident_type.recno}>{incident_type.Value}</option>
                                        })
                                    : <option disabled value="">No Incident Type</option>
                                }
                        </FormControl>
                    </FormGroup>
                    <FormGroup controlId="facility" bsSize="sm">
                        <ControlLabel className="login_label">Facility</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                            style={{width: "100%"}}
                            value={this.state.facility_id ? this.state.facility_id : ""}
                            onChange={(e)=>{this.setState({facility_id: e.target.value})}}>
                                {hasFacilities ? <option value={"select"}>Select Facility</option> : null}
                                {hasFacilities
                                    ? facilities.map((facility) => {
                                            if(facility.is_active == 1)
                                                return <option key={facility.facility_id} value={facility.facility_id}>{facility.facility_name}</option>
                                        })
                                    : <option disabled value="">No Facility</option>
                                }
                        </FormControl>
                    </FormGroup>
                    <FormGroup controlId="facility_location" bsSize="sm">
                        <ControlLabel className="login_label">Location</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                           style={{width: "100%"}}
                           value={this.state.facility_location_id ? this.state.facility_location_id : ""}
                           onChange={(e)=>{this.setState({facility_location_id: e.target.value})}}>
                                {hasFacilityLocations ? <option value={"select"}>Select Location</option> : null}
                                {hasFacilityLocations
                                    ? facility_locations.map((location) => {
                                        if(location.is_active == 1)
                                            return <option key={location.facility_location_id} value={location.facility_location_id}>{location.location_name}</option>
                                        })
                                    : <option disabled value="">No Location</option>
                                }
                        </FormControl>
                    </FormGroup>
                    <FormGroup controlId="location_description" bsSize="sm">
                        <ControlLabel className="login_label">Detailed Location Description</ControlLabel>
                        <FormControl
                            rows={4}
                            componentClass="textarea"
                            placeholder="Enter location details..."
                            value={this.state.location_description}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                </div>

                <div className="right-side-content">

                    { this.state.editMode == true ? this.renderAllIndividualFields() : this.renderIndividualNameFields() }

                    <FormGroup>
                        <Button className="blue-btn" onClick={this.handleAddIndividual}>Add Individual</Button>
                    </FormGroup>
                    <FormGroup>
                        <h3 className="sub-title">Attachments</h3>
                        <div className="attachments-div">
                        {
                            this.state.files.map((file) => {
                                return (
                                    <img key={file.name} className="attachment-image" src={URL.createObjectURL(file)} width={100} height={70}/>
                                )
                            })
                        }
                        </div>
                        <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={this.handleFileChange}/>
                        <Button className="blue-btn" onClick={this.handleAddFile}>Upload File</Button>
                    </FormGroup>
                </div>
            </div>
        )
    }

    renderIndividualNameFields(){

        const elements = [];

        for (var i = 1; i <= this.state.individual_count; i++){

            let controlID = "individual_name_"+i;
            let segmentControl = "individual_role_"+i;
            let narrative = "narrative_"+i;

            elements.push (
                <div className="individual_divider" key={controlID+"_"+i}>
                    <FormGroup controlId={controlID} bsSize="sm">
                        <ControlLabel className="login_label">Individual Name</ControlLabel>
                        <FormControl
                            type="text"
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <SegmentedControl
                        name={segmentControl}
                        options={[
                            { label: "Offender", value: "offender", default: true,},
                            { label: "Witness", value: "witness" },
                            { label: "Victim", value: "victim"},
                            { label: "Other", value: "other" }
                        ]}
                        setValue={(newValue) => {
                            this.setState({[segmentControl] : newValue});
                        }}
                        className="segment-control-tabs"
                        />
                    <FormGroup controlId={narrative} bsSize="sm">
                        <ControlLabel className="login_label">Narrative</ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            rows={4}
                            placeholder="Enter the narrative from the individual details..."
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                </div>
            )
        }

        return elements;
    }

    renderAllIndividualFields(){
        var json_data = UtilsService.sharedInstance.tryParseJSON(this.props.itemToEdit.individuals_data) ? JSON.parse(this.props.itemToEdit.individuals_data) : [];
        //console.log("json_data", json_data);
        var counter = 1;

        const elements = [];

        for (var i = 0; i < this.state.individual_count; i++){
            let controlID = "individual_name_"+counter;
            let individual_role = "individual_role_"+counter;
            let segmentControl = "edit_individual_role_"+counter;
            let narrative = "narrative_"+counter;

            // Declarations:
            var isOffender = true;
            var isWitness = false;
            var isVictim = false;
            var isOther = false;

            var userType = "witness";

            var options = [];

            var option1 = { label: "Offender", value: "offender", default: true}; //default value
            var option2 = { label: "Witness", value: "witness"};
            var option3 = { label: "Victim", value: "victim"};
            var option4 = { label: "Other", value: "other"};

            var individual_name = "";
            var narrative_value = "";

            // Handle if user is not
            let individual = typeof(json_data[i]) == "undefined" ? [] : json_data[i]
            json_data[i] = individual;
            if (json_data[i].length > 0){
                isOffender = json_data[i].type == "offender" ? true : false;
                isWitness = json_data[i].type == "witness" ? true : false;
                isVictim = json_data[i].type == "victim" ? true : false;
                isOther = json_data[i].type == "other" ? true : false;

                userType = json_data[i].type;

                option1 = isOffender ? { label: "Offender", value: "offender", default: true} : { label: "Offender", value: "offender"};
                option2 = isWitness ? { label: "Witness", value: "witness", default: true} : { label: "Witness", value: "witness"};
                option3 = isVictim ? { label: "Victim", value: "victim", default: true} : { label: "Victim", value: "victim"};
                option4 = isOther ? { label: "Other", value: "other", default: true} : { label: "Other", value: "other"};

                individual_name = this.state[controlID] == null ? json_data[i].name : this.state[controlID];
                narrative_value = this.state[narrative] == null ? json_data[i].narrative : this.state[narrative];
            }
            else{
                individual_name = this.state[controlID];
                narrative_value = this.state[narrative];
            }

            options.push(option1);
            options.push(option2);
            options.push(option3);
            options.push(option4);

            elements.push(
                    <div>
                        <FormGroup controlId={controlID} bsSize="sm">
                            <ControlLabel className="login_label">Individual Name</ControlLabel>
                            <FormControl
                                type="text"
                                onChange={this.handleChange}
                                value={individual_name}
                            />
                        </FormGroup>
                        <SegmentedControl
                            name={segmentControl}
                            options={options}
                            setValue={(newValue) => {
                                this.setState({[individual_role] : newValue});
                            }}
                            className="segment-control-tabs"
                        />
                        <FormGroup controlId={narrative} bsSize="sm">
                            <ControlLabel className="login_label">Narrative</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={4}
                                placeholder="Enter the narrative from the individual details..."
                                onChange={this.handleChange}
                                value={narrative_value}
                            />
                        </FormGroup>
                    </div>
            )

            counter+=1;
        }

        return elements;
    }

    renderEmailSection(){
        return(
            <div className="info-section">
                <div className="left-side-content">
                    <FormGroup controlId="email_incident_div">
                        <h3 className="sub-title section-title-with-toggle">External Agency</h3>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            value = {this.state.show_agency_section}
                            onChange={(el, state) => this.handleSwitch(el, state)}
                            name='show_agency_section'
                        />
                    </FormGroup>

                    {this.renderAgencySectionContents()}
                </div>

                <div className="right-side-content">
                    <FormGroup controlId="email_incident_div">
                        <h3 className="sub-title section-title-with-toggle">Email Incident?</h3>
                        <Switch
                                onText = "ON"
                                offText = "OFF"
                                value = {this.state.show_email_section}
                                onChange={(el, state) => this.handleSwitch(el, state)}
                                name='show_email_section'
                        />
                    </FormGroup>
                    {this.renderEmailSectionContents()}
                </div>
            </div>
        )
    }

    renderLinkedFileSection = () =>{
        const {linked_files} = this.state;

        return (
            <div className='info-section'>
                <div className='left-side-content'></div>
                <div className='right-side-content'>
                    <FormGroup>
                        <h3 className='sub-title'>Linked Files</h3>
                    </FormGroup>
                    <FormGroup>
                        <div className='attachments-div'>
                            {
                                linked_files.map((value,key) => {
                                    const {title} = value;
                                    return (
                                        <div>
                                            {title}

                                            <div className='pull-right'>
                                                <Glyphicon
                                                    glyph='remove'
                                                    className='pull-right'
                                                    style={{cursor:'pointer', marginLeft: 10}}
                                                    onClick={() => this.onUnLinkFile(value)}
                                                />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </FormGroup>
                    <Button className='blue-btn' onClick={() => this.setState({ link_modal:true })}>Linked Files</Button>
                </div>
            </div>
        )
    }

    onLinkFile = (data) =>{
        const {linked_files} = this.state;

        linked_files.push(data);

        this.setState({ linked_files });
    }

    onUnLinkFile = (data) =>{
        const {linked_files} = this.state;

        let key = -1;

        for(let x = 0; x < (linked_files).length; x++){
            const {id} = linked_files[x];

            if(id == data.id){
                key = x;
            }
        }

        if(key >= 0){
            linked_files.splice(key, 1);

            this.setState({ linked_files });
        }
    }

    renderLinkedButton = (cell, row) =>{
        const {linked_files} = this.state;

        let linked = false;

        for(let x = 0; x < (linked_files).length; x++){
            const {id} = linked_files[x];

            if(id === row.id){
                linked = true;

                break;
            }
        }

        if(linked){
            return <Button onClick={() => this.onUnLinkFile(row)}>Unlink</Button>
        }

        return <Button onClick={() => this.onLinkFile(row)}>Link</Button>
    }

    renderLinkIncidentDate = (cell, row) => {
        return moment(row.time).format('MM-DD-YYYY');
    }

    renderLinkedModal = () =>{
        const data = this.props.tableData && this.props.tableData.rows ? this.props.tableData.rows : [];
        const {link_modal} = this.state;
        const options = {
            hideSizePerPage: true,
            defaultSortName: 'time',
            defaultSortOrder: 'asc'
        };

        return  (
            <Modal
                show={link_modal}
            >
                <Modal.Header>
                    <b style={{fontSize: 20}}>Link Files</b>
                </Modal.Header>
                <Modal.Body>
                    <BootstrapTable 
                        hover
                        search
                        pagination
                        data={data} 
                        keyField='id'
                        options={options}
                        trClassName={'usersRow'}
                    >
                        <TableHeaderColumn dataField='time' width='10%' dataSort dataFormat={this.renderLinkIncidentDate}>Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='facility' width='10%' dataSort>Venue</TableHeaderColumn>
                        <TableHeaderColumn dataField='event' width='10%' dataSort>Event</TableHeaderColumn>
                        <TableHeaderColumn dataField='location' width='15%'>Location</TableHeaderColumn>
                        <TableHeaderColumn width='10%' dataFormat={this.renderLinkedButton}>Action</TableHeaderColumn>
                    </BootstrapTable>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={() => this.setState({ link_modal: false })}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    renderAgencySectionContents(){
        if (this.state.show_agency_section == false){
            return (
                <div className="section-content"></div>
            )
        }
        return(
            <div className="section-content">
                <hr className="line"/>

                <div className="fire-department">
                    <div className="checkbox-side">
                        <Checkbox
                            id="checkedFireDepartment"
                            name="checkedFireDepartment"
                            inline
                            checked={this.state.checkedFireDepartment === "on"}
                            onChange={(e)=> this.handleCheckBoxTick(e)}>Fire Department</Checkbox>
                    </div>
                    <div className="time-side">
                        <ControlLabel className="left-form-label">Time Dispatched</ControlLabel>
                        <TimePicker id={"time_dispatched"} onChange={(e)=>{this.handleTimeDispatchedChange(e)}} value={this.state.time_dispatched}/>
                    </div>
                </div>
                <div className="fire-department">
                    <div className="checkbox-side">
                        <Checkbox
                            id="checkedPolice"
                            name="checkedPolice"
                            inline
                            checked={this.state.checkedPolice === "on"}
                            onChange={(e)=> this.handleCheckBoxTick(e)}>Police</Checkbox>
                    </div>
                    <div className="time-side">
                        <ControlLabel className="left-form-label">Time Arrived</ControlLabel>
                        <TimePicker id={"time_arrived"}  onChange={(e)=>{this.handleTimeArrivedChange(e)}}  value={this.state.time_arrived}/>
                    </div>
                </div>
                <div className="fire-department">
                    <div className="checkbox-side">
                        <Checkbox
                            id="checkedAmbulance"
                            name="checkedAmbulance"
                            inline
                            checked={this.state.checkedAmbulance === "on"}
                            onChange={(e)=> this.handleCheckBoxTick( e)}>Ambulance</Checkbox>
                    </div>
                    <div className="time-side">
                        <ControlLabel className="left-form-label">Time Cleared</ControlLabel>
                        <TimePicker id={"time_cleared"} onChange={(e)=>{this.handleTimeClearedChange(e)}} value={this.state.time_cleared}/>
                    </div>
                </div>
            </div>
        )
    }

    renderEmailSectionContents(){
        let hasAutoEmails =  this.props.auto_emails ? true : false;
        let auto_emails = this.props.auto_emails;

        if (this.state.show_email_section == false){
            return (
                <div className="section-content"></div>
            )
        }
        return (
            <div className="section-content">
                <hr className="line"/>
                <FormGroup controlId="emai_address" bsSize="sm">
                    <ControlLabel className="login_label">Email Address <span className="gray-text">(will send a PDF Report)</span></ControlLabel>
                    <FormControl  componentClass="select" placeholder="Use Dropdown"
                        style={{width: "100%"}}
                        value={this.state.auto_email_id}
                        onChange={(e)=>{
                            this.setState({auto_email_id: e.target.value});
                        }}>
                            {hasAutoEmails ? <option value={"select"}>Select Auto Email</option> : null}
                            {hasAutoEmails
                                ? auto_emails.map((email) => {
                                    return <option key={email.auto_email_id} value={email.auto_email_id}>{email.auto_email}</option>
                                    })
                                : <option disabled value="select">No Auto Email</option>
                            }
                    </FormControl>
                </FormGroup>
                <Button className="green-btn" onClick={this.handleAddEmail}>Add an Email</Button>
            </div>
        )
    }

    renderFooterSection(){
        let buttonTitle = this.state.editMode == true ? "SAVE CHANGES" : "SUBMIT INCIDENT";

        if (this.state.editMode == true){
            return (
                <div className="footer-section">
                    <hr className="line"/>
                    <Button className="green-btn" onClick={this.handleUpdateIncident}>{buttonTitle}</Button>
                </div>
            )
        }
        else {
            return (
                <div className="footer-section">
                    <hr className="line"/>
                    <Button className="green-btn" onClick={this.convertCanvasToPDF}>{buttonTitle}</Button>
                </div>
            )
        }
    }

    handleSegmentChange(newValue){

    }

    handleFileUpload(){

    }

    handleContinueButton() {

    }

    handleSaveButton(){

    }

    handleTimeDispatchedChange(time){
        this.setState({time_dispatched: time});
    }

    handleTimeArrivedChange(time){
        this.setState({time_arrived: time});
    }

    handleTimeClearedChange(time){
        this.setState({time_cleared: time});
    }

    handleAddIndividual(){
        let newCount = this.state.individual_count+1;
        this.setState({individual_count: newCount});
    }

    handleAddEmail(){

    }

    handleAddFile(){
        this.refs.fileUploader.click();
    }

    handleFileChange = (event) => {
        var files = this.state.files;
        files.push(event.target.files[0]);
        this.setState({files: files});
    }

    handleCheckBoxTick(e){
        const {name, value, id} = e.target;
        let newValue = value;
        if(this.state[id] === "on") {
            newValue = "off";
        }
        else{
            newValue = "on";
        }
        this.setState({[name] : newValue});
    }

    handleSubmitIncident(generatedPDF){
        const {linked_files} = this.state;

        // Generate Individuals Array:

        // Handle Date
        var date = this.state.date_added.getFullYear() + "-" + (this.state.date_added.getMonth() + 1) + "-" + this.state.date_added.getDate();
        var time = this.state.date_added.getHours() + ":" + this.state.date_added.getMinutes() + ":" + this.state.date_added.getSeconds();
        let date_string = date + " " + time;

        const other_form_data = {};
        const incident_ids = [];

        if(linked_files && linked_files.length){
            for(let x = 0; x < (linked_files).length; x++){
                incident_ids.push(linked_files.id);
            }
        }

        var individuals = [];
        for(var i=1; i <= this.state.individual_count; i++){

            var individual = {
                name: this.state['individual_name_'+i],
                type: this.state['individual_role_'+i],
                narrative: this.state['narrative_'+i],
            }

            individuals.push(individual);
        }

        // Generate External Agency:

        var external_agencies = [];
        if (this.state.show_agency_section){
            if (this.state.checkedFireDepartment == "on"){
                var fire_deparment_data = {
                    type: 'fire_department',
                    time_dispatched: this.state.time_dispatched
                }

                external_agencies.push(fire_deparment_data);
            }

            if (this.state.checkedPolice == "on"){
                var police_data = {
                    type: 'police',
                    time_arrived: this.state.time_arrived
                }

                external_agencies.push(police_data);
            }

            if (this.state.checkedAmbulance == "on"){
                var ambulance_data = {
                    type: 'ambulance',
                    time_cleared: this.state.time_cleared
                }

                external_agencies.push(ambulance_data);
            }
        }


        let auto_email_value = this.findAutoEmailById(this.state.auto_email_id);

        other_form_data.linked_files = linked_files;
        other_form_data.incident_ids = incident_ids;


        var params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.user_auth,
            "dispatch_no": '',
            "incident_type_id": this.state.incident_type_id,
            "facility_id": this.state.facility_id,
            "facility_location_id": this.state.facility_location_id,
            "location_description": this.state.location_description,
            "individuals_data": JSON.stringify(individuals),
            "external_agency_data":  JSON.stringify(external_agencies),
            "auto_email_id": this.state.auto_email_id,
            "sub_user_id": this.state.sub_user_id,
            "date_added": date_string,
            "files": this.state.files == null ? [] : this.state.files,
            "auto_email_value": auto_email_value,
            "other_form_data": JSON.stringify(other_form_data)
        }

        this.setState({
            isSubmittingIncident: true,
            submitMessage: "Submitting Incident..."
        });


        IncidentsService.sharedInstance.add(params)
        .then((response)=>{
            //check if PDF is passed and aut email is present
            if(this.state.auto_email_id){
                let emailParams = {
                    "incident":params,
                    "submitted_by":this.state.loginResponse,
                    "pdf":generatedPDF
                }
                this.sendEmail(emailParams);
            }

            ToastStore.success("Successfully Created New Incident!");

            this.props.changeTab();
            this.props.fetchIncidents();

            this.setState({
                isSubmittingIncident: false
            });
        })
    }

    handleUpdateIncident(){
        const {linked_files} = this.state;

        // Generate Individuals Array:

        // Handle Date
        var date = this.state.date_added.getFullYear() + "-" + (this.state.date_added.getMonth() + 1) + "-" + this.state.date_added.getDate();
        var time = this.state.date_added.getHours() + ":" + this.state.date_added.getMinutes() + ":" + this.state.date_added.getSeconds();
        let date_string = date + " " + time;

        const other_form_data = {};
        const incident_ids = [];

        if(linked_files && linked_files.length){
            for(let x = 0; x < (linked_files).length; x++){
                incident_ids.push(linked_files.id);
            }
        }

        var individuals = [];
        var json_data = UtilsService.sharedInstance.tryParseJSON(this.state.individuals_data) ? JSON.parse(this.state.individuals_data) : {};

        for(var i=1; i <= this.state.individual_count; i++){
            var individual = {
                name: this.state['individual_name_'+i],
                type: this.state['individual_role_'+i],
                narrative: this.state['narrative_'+i],
            }

            individuals.push(individual);
        }

        // Generate External Agency:

        var external_agencies = [];
        if (this.state.show_agency_section){
            if (this.state.checkedFireDepartment == "on"){
                var fire_deparment_data = {
                    type: 'fire_department',
                    time_dispatched: this.state.time_dispatched
                }

                external_agencies.push(fire_deparment_data);
            }

            if (this.state.checkedPolice == "on"){
                var police_data = {
                    type: 'police',
                    time_arrived: this.state.time_arrived
                }

                external_agencies.push(police_data);
            }

            if (this.state.checkedAmbulance == "on"){
                var ambulance_data = {
                    type: 'ambulance',
                    time_cleared: this.state.time_cleared
                }

                external_agencies.push(ambulance_data);
            }
        }


        let auto_email_value = this.findAutoEmailById(this.state.auto_email_id);

        other_form_data.linked_files = linked_files;
        other_form_data.incident_ids = incident_ids;


        var params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.user_auth,
            "dispatch_no": this.state.dispatch_no,
            "incident_type_id": this.state.incident_type_id,
            "facility_id": this.state.facility_id,
            "facility_location_id": this.state.facility_location_id,
            "location_description": this.state.location_description,
            "individuals_data": JSON.stringify(individuals),
            "external_agency_data":  JSON.stringify(external_agencies),
            "auto_email_id": this.state.auto_email_id,
            "sub_user_id": this.state.sub_user_id,
            "date_added": date_string,
            "files": this.state.files == null ? [] : this.state.files,
            "id": this.props.itemToEdit.id,
            "other_form_data":JSON.stringify(other_form_data),
            "update_attachments_flag": 1
        }

        this.setState({
            isSubmittingIncident: true,
            submitMessage: "Updating Incident..."
        });


        IncidentsService.sharedInstance.edit(params)
        .then((response)=>{
            if (response.success == 1){
                ToastStore.success("Successfully Updated Incident!");
                this.props.fetchIncidents();
                this.props.changeTab();
            }

            else {
                ToastStore.error("Failed to update incident!");
            }
            //check if PDF is passed and aut email is present
            // if(this.state.auto_email_id){
            //     let emailParams = {
            //         "incident":params,
            //         "submitted_by":this.state.loginResponse,
            //         "pdf":generatedPDF
            //     }
            //     this.sendEmail(emailParams);
            // }
            this.setState({
                isSubmittingIncident: false,
            });
        })
    }

    isValidForm(params){
        var requiredFields = [
                                "first_name",
                                "last_name",
                                "username",
                                "password",
                                "user_type",
                                "branch",
                                "email"
                            ];

        var validationForFields = [
                                // {name: "first_name", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str)}},
                                // {name: "last_name", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str)}},
                                // {name: "username", checkRegex: (str)=>{ return true}},
                                // {name: "password", checkRegex: (str)=>{ return true}},
                                // {name: "hire_date", checkRegex: (str)=>{
                                //     var isCorrectFormat = /((0?[13578]|10|12)(-|\/)((0[0-9])|([12])([0-9]?)|(3[01]?))(-|\/)((\d{4})|(\d{2}))|(0?[2469]|11)(-|\/)((0[0-9])|([12])([0-9]?)|(3[0]?))(-|\/)((\d{4}|\d{2})))/.test(str)
                                //         return isCorrectFormat || str == null || str.toString().replace(/ /g,'') == ''
                                //     }
                                // },
                                // {name: "work_phone", checkRegex: (str)=>{
                                //         return (/[0-9]/.test(str) && str.length == 10) || str == null || str.replace(/ /g,'') == ''
                                //     }
                                // },
                                // {name: "mobile_phone", checkRegex: (str)=>{
                                //     console.log("mobile Phone: ", str);
                                //         return (/[0-9]/.test(str) && str.length == 10) || str == null || str.replace(/ /g,'') == ''
                                //     }
                                // },
                                // {name: "email", checkRegex: (str)=>{ return str.indexOf("@") >= 1}},
                                // {name: "date_of_birth", checkRegex: (str)=>{
                                //     var isCorrectFormat = /((0?[13578]|10|12)(-|\/)((0[0-9])|([12])([0-9]?)|(3[01]?))(-|\/)((\d{4})|(\d{2}))|(0?[2469]|11)(-|\/)((0[0-9])|([12])([0-9]?)|(3[0]?))(-|\/)((\d{4}|\d{2})))/.test(str)
                                //     return isCorrectFormat || str == null || str.toString().replace(/ /g,'') == ''
                                // }},
                                // {name: "address", checkRegex: (str)=>{ return true}},
                                // {name: "city", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str) || str == null || str.replace(/ /g,'') == ''}},
                                // {name: "state", checkRegex: (str)=>{ return true}},
                                // {name: "zipcode", checkRegex: (str)=>{ return true}},
                            ];

        var isValid = true;
        var missingFields = "";
        var invalidFields = "";

        Object.keys(params).map((key, index) => {
            var isRequiredField = requiredFields.indexOf(key) >= 0;
            var fieldIsEmpty = (params[key] == null || params[key].toString().replace(/ /g,'') == '');
            if((isRequiredField && fieldIsEmpty)) {
                isValid = false;

                var frags = key.split('_');
                var i = 0;
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }

                frags = frags.join(' ');
                if(missingFields == "") {
                    missingFields+= " "+frags;
                } else {
                    missingFields+= ", "+frags;
                }
            }
        });

        if(!isValid) {
            //Replace with bootstrap modals in teh future for more customized look -Tere
            //If modal for this is implemented, combine with invalidFields and remove from this if-block.
            //modal should list both alerts at the same time (this alert and the one for regex)
            alert("Invalid Form! These fields are required: " + missingFields);
        }
        else {
            var existingValidator = null;

            Object.keys(params).map((key, index) => {
                var isRequiredField = requiredFields.indexOf(key) >= 0;
                existingValidator = _.find(validationForFields, (field)=>{ return field.name == key});

                if (existingValidator && (!existingValidator.checkRegex(params[key])) ) {
                    isValid = false;

                    var frags = key.split('_');
                    var i = 0;

                    for (i=0; i<frags.length; i++) {
                        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                    }

                    frags = frags.join(' ');

                    if (invalidFields == "") {
                        invalidFields+= " "+frags;
                    } else {
                        invalidFields+= ", "+frags;
                    }
                }
            });

            if (!isValid) {
                //Replace with bootstrap modals in teh future for more customized look -Tere
                alert("Invalid Form! These fields are invalid: " + invalidFields);
            }
        }

        return isValid;
    }

    handleChange = event => {
        var value = event.target.value;

        this.setState({
            [event.target.id]: value,
            hasChanged: true,
        });
    }

    handleSwitch(elem, state) {
        let name = elem.props.name;

        if (name == 'show_email_section' && state== false){

            // Reset auto email value:
            var email_value = '';
            this.setState({[name]: state, auto_email_id: email_value});
        }

        else {
            this.setState({[name]: state});
        }
    }

    sendEmail(params){
        let name =  params.submitted_by.data[0].first_name + " " + params.submitted_by.data[0].last_name;
        let emailParams = {
          file: params.pdf,
          token: params.submitted_by.token_data.token,
          license: params.submitted_by.data[0].User_License,
          auth_username: params.submitted_by.data[0].User_ID,
          from_email: params.submitted_by.data[0].email ? params.submitted_by.data[0].email : "support@archontech.com",
          from_name: name ? name : "support@archontech.com",
          send_to_email: params.incident.auto_email_value,
          send_to_name: params.incident.auto_email_value,
          content: '<h1>'+name+' submitted incident form.</h1>',
          subject: 'Incident Form'
        }
        EmailService.sharedInstance.send(emailParams).then((response)=>{
        })
        .catch((err)=>{
          ToastStore.error("Email submission!");
          console.log("error: ", err);
        })
    }


    convertCanvasToPDF(json_string, files){
        var componentToConvert = document.getElementById('IncidentCanvasForm');//$("#canvasWindow");

        html2canvas(componentToConvert)
        .then((canvas)=>{
            // var image = canvas.toDataURL("image/jpeg")
            // var pdf=new jsPDF("p", "mm", "a4");
            // var width = pdf.internal.pageSize.getWidth();
            // var height = pdf.internal.pageSize.getHeight();
            // height = ratio * width;
            // pdf.addImage(image, 'JPEG', 0, 0,width-20, height-10);
            // let finalPDF = pdf.output('blob');
            // this.handleSubmitIncident(finalPDF);
            var wid = canvas.width;
            var hgt = canvas.height;
            var img = canvas.toDataURL("image/png", wid, hgt);
            var hratio = hgt/wid
            var pdf = new jsPDF('p','pt','a4');
            var width = pdf.internal.pageSize.width;
            var height = width * hratio
            pdf.addImage(img,'JPEG',20,20, width, height);
            let finalPDF = pdf.output('blob');
            // this.state.editMode==true ? this.handleUpdateIncident(finalPDF) : this.handleSubmitIncident(finalPDF);
            this.handleSubmitIncident(finalPDF);
        })
        .catch((e)=>{
           console.log("canvas error: ", e);
           return e;
        })
    }

    findIncidentID(incident){
        let hasIncidentTypes =  this.props.incident_types ? true : false;
        let incident_types = this.props.incident_types;
        let incident_id="";
        if(hasIncidentTypes){
            incident_types.forEach(function (incident_type) {
                if(incident_type.Value == incident){
                    incident_id = incident_type.recno;
                }
            });
        }
        return incident_id;
    }

    findAutoEmailById(id){
        let hasAutoEmails =  this.props.auto_emails ? true : false;
        let autoEmails = this.props.auto_emails;
        let autoEmailValue="";
        if(hasAutoEmails){
            autoEmails.forEach(function (email, index) {
                if(email.auto_email_id == id){
                    autoEmailValue = email.auto_email;
                }
            });
        }
        return autoEmailValue;
    }

    findFacilityID(facility_name){
        let hasFacilities =  this.props.facilities ? true : false;
        let facilities = this.props.facilities;
        let facility_id="";
        if(hasFacilities){
            facilities.forEach(function (facility) {
                if(facility.facility_name == facility_name){
                    facility_id = facility.facility_id;
                }
            });
        }
        return facility_id;
    }

    getExternalAgencyValue(agency_name){
        const {external_agency_data} = this.props.itemToEdit;

        const json_data = external_agency_data ? JSON.parse(external_agency_data) : [];
        let result = [false, ""]; //set to -1 if agency is not found in DB

        json_data.map((item) => {
            if (item.type == agency_name){
                switch (agency_name){
                    case 'fire_department':
                        result["isChecked"] = true;
                        result["time"] = item.time_dispatched;
                        break;

                    case 'police':
                        result["isChecked"] = true;
                        result["time"] = item.time_arrived;
                        break;

                    case 'ambulance':
                        result["isChecked"] = true;
                        result["time"] = item.time_cleared;
                        break;

                    default:
                        break;
                }
            }
        })

        return result;
    }
}

export default AddIncident;
